export const promocodeRewardDialogStyles = {
  overlay: [
    "fixed inset-0 z-50 bg-black/80",
    "data-[state=open]:animate-in data-[state=open]:fade-in-0",
    "data-[state=closed]:animate-out data-[state=closed]:fade-out-0",
  ].join(" "),

  content: [
    "fixed inset-0 z-50 flex flex-col items-center justify-center overflow-hidden bg-primary-main pt-[92px] pb-5",
    "data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95",
    "data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95",
  ].join(" "),

  graphic: "relative flex flex-1 items-center justify-center gap-4 p-4 w-full",

  contentWrapper: "relative z-10 flex w-full flex-col",

  body: "flex w-full flex-col items-center justify-center gap-4 p-4 text-center",

  titleBlock: "flex w-full flex-col items-center justify-center gap-1",

  title:
    "text-[32px] leading-[normal] font-bold tracking-[-1.5px] text-white",

  giftName:
    "text-[32px] leading-[normal] font-bold tracking-[-1.5px] text-white",

  textBlock:
    "flex w-full flex-col gap-1 text-center text-base leading-[1.3] tracking-[-0.5px]",

  description: "w-full text-center text-white",

  wagerRequirement: "w-full text-center text-green-100",

  ctaWrapper: "flex w-full flex-col p-4",

  cta: [
    "flex h-12 w-full items-center justify-center gap-1 rounded-2xl bg-green-100",
    "text-base/none font-bold tracking-[-0.5px] text-black-100",
    "transition-opacity active:opacity-80",
  ].join(" "),
} as const
